import Layout from 'components/layout'
import { NextSeo } from 'next-seo'
import { HOST } from 'config'
import { CommonJsonLd } from 'components/json-ld'
import Breadcrumb from 'components/breadcrumb'

const Index = (): JSX.Element => {
  return (
    <Layout showDownloadBtn={false}>
      <NextSeo
        title="Stories, Web Novels & Book Reviews & Recommendations - AnyStories"
        description="Get lastest trends and views into web novels and stories on AnyStories book reviews & recommendations channel. Navigate the vast literary world and find your next read."
        canonical={`${HOST}/blog`}
      />
      <CommonJsonLd />
      <div className="hidden lg:block px-4 py-3">
        <Breadcrumb
          className="mr-4"
          items={[
            {
              name: 'Contact Us',
            },
          ]}
        />
      </div>
      <h4 className="mt-8 text-center font-bold text-xl">contact us</h4>
      <div className="w-3/4 min-h-[450px] desktop:w-1/2 mx-auto my-8 leading-7">
        If you need assistance or have any questions, please feel free to
        contact us.
        <br />
        Our contact information is{' '}
        <a
          href="mailto:support@anystorites.app"
          className="text-blue text-opacity-80"
        >
          support@anystorites.app
        </a>
        .
        <br />
        <br />
        Company Name: Owego CO.,Limied
        <br />
        Tel: +86 021-54393188
        <br />
        Registration No.: TX 9-329-453
        <br />
        Registration Address: UNIT D18 3/F WONG KING INDUSTRIAL BUILDING NO.2-4
        TAI YAU STREET KL
        <br />
      </div>
    </Layout>
  )
}

export default Index
